module.exports = __webpack_public_path__ + "img/pad_banner.a41b5682.png";